class SceneObjectUrlSyncConfig {
  constructor(_sceneObject, _options) {
    this._sceneObject = _sceneObject;
    this._keys = _options.keys;
  }
  getKeys() {
    return this._keys;
  }
  getUrlState() {
    return this._sceneObject.getUrlState();
  }
  updateFromUrl(values) {
    this._sceneObject.updateFromUrl(values);
  }
}

export { SceneObjectUrlSyncConfig };
//# sourceMappingURL=SceneObjectUrlSyncConfig.js.map
